export const PASSWORD = 'password';
export const NUMBER = 'number';
export const ALPHA_NUMERIC = 'alpha_numeric';
export const DECIMAL = 'decimal';
export const EMAIL = 'email';
